import { FireBaseError } from '../../util/constants'
import { NOTIFICATIONS } from '../../util/notification'

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

export const FirebaseErrorHandling = (code: string) => {
  switch (code) {
    case FireBaseError.INVALID_PASSWORD:
      return { message: FireBaseError.WRONG_PASSWORD }

    case FireBaseError.TOO_MANY_ATTEMPT:
      return { message: NOTIFICATIONS.ERROR.tooManyAttempts }
  }
}
